import { createSlice } from "@reduxjs/toolkit";

const initialState = { isAuthenticated: localStorage.getItem("accessToken"), loginDetails: {} };

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLogin(state, action) {
      state.isAuthenticated = true;
    },
    setLogout(state, action) {
      state.isAuthenticated = false;
      localStorage.clear();
    },
    setLoginDetails(state, action) {
      state.loginDetails = { ...state.loginDetails, ...action.payload }
    }
  },
});

export const authActions = authSlice.actions;
export default authSlice;
